import { Routes } from "@angular/router";
import { cmViewGuard } from "../../core/authentication/auth.guard";
import { Bq8RootComponent } from "./pages/bq8/bq8-root.component";
import { CompletedItemsComponent } from "./pages/completed-items/completed-items.component";
import { CmRootComponent } from "./root/cm-root.component";
import { LotSummaryComponent } from "./pages/lot-summary/lot-summary.component";
import { JobScheduleComponent } from "./pages/job-schedule/job-schedule.component";
import { AllMyLotsComponent } from "./pages/all-my-lots/all-my-lots.component";
import { MyProfileComponent } from "../shared/profile/my-profile.component";
import { Bq9RootComponent } from "./pages/bq9/bq9-root.component";
import { Bq9CelebrationComponent } from "./pages/bq9/celebration/bq9-celebration.component";
import { Bq9IssueDetailsComponent } from "./pages/bq9/issue-details/bq9-issue-details.component";
import { Bq9NotCompleteComponent } from "./pages/bq9/not-complete/bq9-not-complete.component";
import { Bq9ReviewAndSignComponent } from "./pages/bq9/review-and-sign/bq9-review-and-sign.component";
import { Bq9SubmissionComponent } from "./pages/bq9/submission/bq9-submission.component";
import { JobFinalReviewComponent } from "../../domains/jobs/components/job-final-review/job-final-review.component";
import { JobIssueListComponent } from "../../domains/jobs/components/job-issue-list/job-issue-list.component";
import { JobNeedsAttentionComponent } from "../../domains/jobs/components/job-needs-attention/job-needs-attention.component";
import JobScheduleChecklist from "../../domains/jobs/components/job-schedule-checklist/job-schedule-checklist.component";
import { JobSubmissionComponent } from "../../domains/jobs/components/job-submission/job-submission.component";
import { JobOverviewComponent } from "../ccm/pages/bq7/overview/job-overview.component";
import { Bq6RootComponent } from "./pages/bq6/bq6-root.component";
import { Bq1RootComponent } from "./pages/bq1/bq1-root.component";
import { Bq2RootComponent } from "./pages/bq2/bq2-root.component";
import { Bq3RootComponent } from "./pages/bq3/bq3-root.component";
import { Bq4RootComponent } from "./pages/bq4/bq4-root.component";
import { Bq5RootComponent } from "./pages/bq5/bq5-root.component";
import { JobSingleAreaChecklistComponent } from "../../domains/jobs/components/job-single-area-checklist/job-single-area-checklist.component";
import { OpenItemsRootComponent } from "./pages/open-items/open-items-root.component";
import { OpenItemsComponent } from "./pages/open-items/open-items-list/open-items.component";
import { PrintItemsComponent } from "./pages/open-items/open-items-print-view/print-items.component";
import { JobDiscussAndDemonstrateChecklistComponent } from "../../domains/jobs/components/job-discuss-and-demonstrate-checklist/job-discuss-and-demonstrate-checklist.component";
import { JobDiscussAndDemonstrateFinalReviewComponent } from "../../domains/jobs/components/job-discuss-and-demonstrate-final-review/job-discuss-and-demonstrate-final-review.component";

export const CM_ROUTES: Routes = [
  {
    path: "",
    component: CmRootComponent,
    children: [
      {
        path: "",
        redirectTo: "schedule",
        pathMatch: "full"
      },
      {
        path: "schedule",
        canActivate: [cmViewGuard],
        component: JobScheduleComponent
      },
      {
        path: "all-my-lots",
        redirectTo: "all-my-lots/community/0",
        pathMatch: "full"
      },
      {
        path: "all-my-lots/community/:communityId",
        canActivate: [cmViewGuard],
        component: AllMyLotsComponent
      },
      {
        path: "profile",
        component: MyProfileComponent
      }
    ]
  },
  {
    path: "bq1/job/:jobId",
    canActivate: [cmViewGuard],
    component: Bq1RootComponent,
    data: {
      bqStep: "BQ1"
    },
    children: [{
      path: "",
      redirectTo: "list",
      pathMatch: "full"
    }, {
      path: "list",
      component: JobDiscussAndDemonstrateChecklistComponent
    }, {
      path: "final-review",
      component: JobDiscussAndDemonstrateFinalReviewComponent
    }, {
      path: "submission",
      component: JobSubmissionComponent
    }]
  },
  {
    path: "bq2/job/:jobId",
    canActivate: [cmViewGuard],
    component: Bq2RootComponent,
    data: {
      bqStep: "BQ2"
    },
    children: [{
      path: "",
      redirectTo: "list",
      pathMatch: "full"
    }, {
      path: "list",
      component: JobSingleAreaChecklistComponent
    }, {
      path: "submission",
      component: JobSubmissionComponent
    }]
  },
  {
    path: "bq3/job/:jobId",
    canActivate: [cmViewGuard],
    component: Bq3RootComponent,
    data: {
      bqStep: "BQ3"
    },
    children: [{
      path: "",
      redirectTo: "list",
      pathMatch: "full"
    }, {
      path: "list",
      component: JobSingleAreaChecklistComponent
    }, {
      path: "submission",
      component: JobSubmissionComponent
    }]
  },
  {
    path: "bq4/job/:jobId",
    canActivate: [cmViewGuard],
    component: Bq4RootComponent,
    data: {
      bqStep: "BQ4"
    },
    children: [{
      path: "",
      redirectTo: "list",
      pathMatch: "full"
    }, {
      path: "list",
      component: JobSingleAreaChecklistComponent
    }, {
      path: "submission",
      component: JobSubmissionComponent
    }]
  },
  {
    path: "bq5/job/:jobId",
    canActivate: [cmViewGuard],
    component: Bq5RootComponent,
    data: {
      bqStep: "BQ5"
    },
    children: [{
      path: "",
      redirectTo: "list",
      pathMatch: "full"
    }, {
      path: "list",
      component: JobDiscussAndDemonstrateChecklistComponent
    }, {
      path: "final-review",
      component: JobDiscussAndDemonstrateFinalReviewComponent
    }, {
      path: "submission",
      component: JobSubmissionComponent
    }]
  },
  {
    path: "bq6/job/:jobId",
    canActivate: [cmViewGuard],
    component: Bq6RootComponent,
    data: {
      bqStep: "BQ6"
    },
    children: [
      {
        path: "",
        redirectTo: "overview/locations",
        pathMatch: "full"
      },
      {
        path: "overview/:activeTab",
        component: JobOverviewComponent
      },
      {
        path: "area/:areaId",
        component: JobScheduleChecklist
      },
      {
        path: "area/:areaId/component/:componentId/assertion/:assertionId/issue/:issueId",
        component: JobNeedsAttentionComponent,
        data: {
          isIssue: true
        }
      },
      {
        path: "area/:areaId/component/:componentId/assertion/:assertionId/needs-attention",
        component: JobNeedsAttentionComponent,
        data: {
          isIssue: true
        }
      },
      {
        path: "area/:areaId/component/:componentId/assertion/:assertionId/issues/:issueId/details",
        component: JobNeedsAttentionComponent,
        data: {
          isIssue: true
        }
      },
      {
        path: "area/:areaId/component/:componentId/assertion/:assertionId/details",
        component: JobNeedsAttentionComponent
      },
      {
        path: "area/:areaId/component/:componentId/assertion/:assertionId/issues",
        component: JobIssueListComponent
      },
      {
        path: "final-review",
        component: JobFinalReviewComponent
      },
      {
        path: "submission",
        component: JobSubmissionComponent
      },
    ]
  },
  {
    path: "bq8/job/:jobId",
    canActivate: [cmViewGuard],
    component: Bq8RootComponent,
    data: {
      bqStep: "BQ8"
    },
    children: [{
      path: "",
      redirectTo: "list",
      pathMatch: "full"
    }, {
      path: "list",
      component: JobDiscussAndDemonstrateChecklistComponent
    }, {
      path: "final-review",
      component: JobDiscussAndDemonstrateFinalReviewComponent
    }, {
      path: "submission",
      component: JobSubmissionComponent
    }]
  },
  {
    path: "bq9/job/:jobId",
    canActivate: [cmViewGuard],
    component: Bq9RootComponent,
    children: [
      {
        path: "",
        redirectTo: "celebration",
        pathMatch: "full"
      },
      {
        path: "celebration",
        component: Bq9CelebrationComponent,
        children: [
          {
            path: "area/:areaId/issue/:issueId/edit",
            component: Bq9NotCompleteComponent
          },
          {
            path: "add-item",
            component: Bq9NotCompleteComponent,
            data: { isAddNewItem: true }
          }
        ]
      },
      {
        path: "celebration/area/:areaId/issue/:issueId",
        component: Bq9IssueDetailsComponent,
        children: [
          {
            path: "not-complete",
            component: Bq9NotCompleteComponent
          }
        ]
      },
      {
        path: "celebration/review-and-sign",
        component: Bq9ReviewAndSignComponent
      },
      {
        path: "celebration/submission",
        component: Bq9SubmissionComponent
      },
    ]
  },
  {
    path: "all-my-lots/community/:communityId/lot/:lotId/completed",
    component: CompletedItemsComponent
  },
  {
    path: "all-my-lots/community/:communityId/lot/:lotId/summary",
    component: LotSummaryComponent
  },
  {
    path: "all-my-lots/community/:communityId/lot/:lotId/open-items",
    component: OpenItemsRootComponent,
    children: [
      {
        path: "",
        redirectTo: "list",
        pathMatch: "full"
      },
      {
        path: "list",
        component: OpenItemsComponent
      },
      {
        path: "print",
        component: PrintItemsComponent
      }
    ]
  }
];

export const CM_REDIRECT_ROUTES: Routes = [
  {
    path: "bq7-review",
    redirectTo: "/cm/schedule",
    pathMatch: "full"
  },
  {
    path: "bq7-review/lot/:lotId/summary",
    redirectTo: "/cm/lot/:lotId/summary",
    pathMatch: "full"
  },
  {
    path: "bq7-review/lot/:lotId",
    redirectTo: "/cm/lot/:lotId/open-items-old",
    pathMatch: "full"
  },
  {
    path: "bq7-review/lot/:lotId/completed",
    redirectTo: "/cm/lot/:lotId/completed",
    pathMatch: "full"
  },
  {
    path: "bq7-review/all-my-lots/community/:communityId",
    redirectTo: "/cm/all-my-lots/community/:communityId",
    pathMatch: "full"
  },
  {
    path: "bq7-review/all-my-lots/community/:communityId/lot/:lotId/summary",
    redirectTo: "/cm/all-my-lots/community/:communityId/lot/:lotId/summary",
    pathMatch: "full"
  },
  {
    path: "bq7-review/all-my-lots/community/:communityId/lot/:lotId",
    redirectTo: "/cm/all-my-lots/community/:communityId/lot/:lotId/open-items-old",
    pathMatch: "full"
  },
  {
    path: "bq7-review/lot/:lotId/print",
    redirectTo: "/cm/lot/:lotId/print",
    pathMatch: "full"
  },
  {
    path: "bq7-review/all-my-lots/community/:communityId/lot/:lotId/print",
    redirectTo: "/cm/all-my-lots/community/:communityId/lot/:lotId/print",
    pathMatch: "full"
  },
  {
    path: "bq8/job/:jobId",
    redirectTo: "/cm/bq8/job/:jobId",
    pathMatch: "full"
  },
  {
    path: "bq8/job/:jobId/final-review",
    redirectTo: "/cm/bq8/job/:jobId/final-review",
    pathMatch: "full"
  },
  {
    path: "bq8/job/:jobId/submission",
    redirectTo: "/cm/bq8/job/:jobId/submission",
    pathMatch: "full"
  }
];